import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Home = createSvgIcon(
  <path d="M22.96 9.237 12 .031 1.04 9.237l1.21 1.44V24h19.5V10.678l1.21-1.44Zm-3.46.032V21.75H15V16.5H9v5.25H4.5V9.27l7.5-6.3 7.5 6.3Z" />,
  'Home'
);

export { Home };
